import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MDBDatePickerComponent, ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { BodegaService } from 'src/app/services/bodega.service';
import { CondicionPagoService } from 'src/app/services/condicion-pago.service';
import { DireccionService } from 'src/app/services/direccion.service';
import { DocumentoService, IFechaVencimientoQueryParams } from 'src/app/services/documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { VendedorRubroClienteService } from 'src/app/services/vendedor-rubro-cliente.service';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalDocsReferenciaComponent } from 'src/app/views/shared/modal-docs-referencia/modal-docs-referencia.component';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';

@Component({
  selector: 'app-cabecera-nota-venta',
  templateUrl: './cabecera-nota-venta.component.html',
  styleUrls: ['./cabecera-nota-venta.component.scss'],
  providers: [SecurityService],
})
export class CabeceraNotaVentaComponent implements OnInit {

  @Input() permiteUnidadNegocio: boolean = false;
  @Input() optionsUnidadesDeNegocio: unidad_negocio[] = []

  @Output() onHeaderDataChange: EventEmitter<any> = new EventEmitter<any>()

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalDocsReferenciaComponent, { static: true }) modalDocsReferencias: ModalDocsReferenciaComponent
  @ViewChild('datePickerFechaVencimiento', { static: true }) datePickerFechaVencimiento: MDBDatePickerComponent

  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  enableContent: boolean = true
  cliente: any = null
  sucursal: any = null

  optionsBodega: Array<any> = [];
  optionsSucursal: Array<any> = [];
  optionsVendedor: Array<any> = [];
  // optionsListaPrecio: Array<any> = [];
  optionsCondicionPago: Array<any> = []
  nvFolio: number = 0;
  CountListDocRef: number = 0;
  documentRef: Array<any> = [];
  NvCabecera: any = null;

  // Utils
  private log: any

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private bodegaServ: BodegaService,
    private condicionPagoService: CondicionPagoService,
    private clog: ConsoleService,
    private rutService: RutService,
    private direccionService: DireccionService,
    private vendedorRubroClienteService: VendedorRubroClienteService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private datesService: DatesService,
    private documentoService: DocumentoService,
  ) {
    this.log = this.clog.log('NOTA-VENTA-CABECERA')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.loadBodegas()
    this.loadCondicionPago()

    this.createForms()
    this.formHeader.get('descuento').disable()
    this.formChangesSubscriptions()
  }

  loadBodegas() {
    this.bodegaServ.GetBodegas(this.rutEmpresa, this.sucursalEmpresa, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega => ({
        value: bodega.codigo,
        label: bodega.nombre,
        sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo
      }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega)
    })
  }

  loadCondicionPago() {
    this.condicionPagoService.Get(this.rutEmpresa, this.sucursalEmpresa, ({ registros }) => {
      this.optionsCondicionPago = registros.map(condicionPago => ({
        value: condicionPago.codigo,
        label: condicionPago.descripcion,
        ...condicionPago
      }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('condicionPago'), this.optionsCondicionPago)
    })
  }

  private createForms() {
    const now = this.datesService.CurrentDateToShortTimeString()
    this.formHeader = this.fb.group({
      fechaDoc: [now, [Validators.required]],
      fechaVenc: [null, [Validators.required]],
      bodega: [null, [Validators.required]],
      unidad_negocio_codigo: [null, [Validators.required]],
      rutCliente: [null, [Validators.required]],
      sucursal: [null, [Validators.required]],
      condicionPago: [null, [Validators.required]],
      oc: [null, [Validators.min(0)]],
      descuento: [null, [Validators.min(0), Validators.max(100)]],
      vendedor: [null, [Validators.required]],
      listaPrecios: [null, [Validators.required]],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente)
        this.modalSeleccionarCliente.cleanLast()
      })

    this.formHeader.get("sucursal").valueChanges.subscribe(sucursal => {
      this.handleDireccionChange(sucursal)
    })

    this.formHeader.get("fechaDoc").valueChanges.subscribe(value => {
      this.fetchFechaVencimiento()
    })

    this.formHeader.get("condicionPago").valueChanges.subscribe(value => {
      this.fetchFechaVencimiento()
    })

    // this.formHeader.get("vendedor").valueChanges.subscribe(vendedor => {
    //   this.handleVendedorChange(vendedor)
    // })
  }

  private createHeaderData() {
    const { cliente, sucursal } = this
    return {
      cliente,
      sucursal,
      vendedor: this.formHeader.get('vendedor').value
    }
  }


  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show()
  }

  //CARGAR DATOS NOTA DE VENTA CABECERA
  Load(nv) {
    this.log('Load - Iniciando carga de nota de venta:', nv);

    //RELLENAR INFORMACION DE NOTA VENTA
    const cabecera = nv.cabecera;
    this.NvCabecera = nv.cabecera;

    if (cabecera) {
      this.nvFolio = nv.folio;
      if (cabecera.ordenCompra && cabecera.ordenCompra.length > 0) {
        this.getCountListDocRef(cabecera.ordenCompra);
        this.modalDocsReferencias.load(cabecera.fechaDocumento, cabecera.ordenCompra);
      }

      const rutuser = this.rutService.AgregarDV(cabecera.rutCliente);

      // Establecer valores del formulario
      this.formHeader.get('unidad_negocio_codigo').setValue(cabecera.unidad_negocio_codigo);
      this.formHeader.get('fechaDoc').setValue(cabecera.fechaDocumento);
      this.formHeader.get('fechaVenc').setValue(cabecera.fechaVencimiento);
      this.formHeader.get('rutCliente').setValue(rutuser);
      this.formHeader.get('bodega').setValue(cabecera.codigoBodega);
      this.formHeader.get('sucursal').setValue(cabecera.codigoSucural);
      this.formHeader.get('vendedor').setValue(cabecera.codigoVendedor);
      this.formHeader.get('condicionPago').setValue(cabecera.condicionPago);
      this.formHeader.get('oc').setValue(cabecera.ordenCompra);
      this.formHeader.get('descuento').setValue(cabecera.porcentajeDescuento);
      this.formHeader.get('listaPrecios').setValue(cabecera.codigoListaPrecio);

      this.log('Load - Valores del formulario establecidos');
      this.log('Load - Condición de pago:', cabecera.condicionPago);
      this.log('Load - Vendedor:', cabecera.codigoVendedor);
      this.log('Load - Unidad de negocio:', cabecera.unidad_negocio_codigo);

      // Cargar datos del cliente para obtener información adicional
      this.cliente = {
        rut: cabecera.rutCliente,
        rutFormato: rutuser,
        lista_precio_codigo: cabecera.codigoListaPrecio,
        descuento_maximo: cabecera.porcentajeDescuento
      };

      // Cargar sucursales del cliente
      this.fetchSucursal(cabecera.rutCliente);

      // Cargar vendedores después de que se carguen las sucursales
      setTimeout(() => {
        if (cabecera.codigoSucural) {
          this.fetchVendedor(cabecera.rutCliente, cabecera.codigoSucural);
        }
      }, 500);

      // Establecer condición de pago si está disponible
      if (cabecera.condicionPago) {
        setTimeout(() => {
          this.setCondicionPagoByCodigo(cabecera.condicionPago);
        }, 1000);
      }

    } else {
      this.formHeader.get('oc').setValue(0);
    }

    // this.formHeader.get('').setValue(nv.vendedor_codigo)
  }

  onClienteSeleccionado({ data, origen }) {
    this.log('onClienteSeleccionado')
    this.cleanClientDataAndRelated()
    this.cliente = data
    this.cliente.rutFormato = this.rutService.AgregarDV(this.cliente.rut)
    this.formHeader.get('rutCliente').setValue(this.cliente.rutFormato)
    this.formHeader.get('listaPrecios').setValue(this.cliente.lista_precio_codigo)
    this.formHeader.get('descuento').setValue(this.cliente.descuento_maximo)
    this.onHeaderDataChange.emit(this.createHeaderData())
    this.fetchSucursal(this.cliente.rut)
  }

  cleanClientDataAndRelated() {
    this.cliente = null

    this.optionsSucursal = []
    this.formHeader.get('rutCliente').markAsPristine()
    this.formHeader.get('rutCliente').markAsUntouched()

    this.formHeader.get('sucursal').setValue(null)
    this.formHeader.get('sucursal').markAsPristine()
    this.formHeader.get('sucursal').markAsUntouched()

    this.formHeader.get('vendedor').setValue(null)
    this.formHeader.get('vendedor').markAsPristine()
    this.formHeader.get('vendedor').markAsUntouched()

    this.optionsVendedor = []
    this.sucursal = null
  }

  onClienteNoEncontrado() {
    this.log('onClienteNoEncontrado')
    this.cliente = null
    this.cleanClientDataAndRelated()
    this.onHeaderDataChange.emit(this.createHeaderData())
  }

  private fetchSucursal(cliente_proveedor_rut) {
    const inputParams: any = {
      empresa_rut: this.rutEmpresa,
      // sucursal_codigo: this.sucursalEmpresa,
      cliente_proveedor_rut
    }

    this.direccionService.GetByCliente(inputParams, ({ registros }) => {
      this.optionsSucursal = registros.map(direccion => ({
        value: direccion.codigo,
        label: direccion.direccion_completa,
        ...direccion
      }))

      // Si estamos en modo edición y ya tenemos una sucursal seleccionada, establecerla
      if (this.NvCabecera && this.NvCabecera.codigoSucural) {
        const sucursalSeleccionada = this.optionsSucursal.find(s => s.value === this.NvCabecera.codigoSucural);
        if (sucursalSeleccionada) {
          this.sucursal = sucursalSeleccionada;
          // Establecer la condición de pago basada en la sucursal
          if (sucursalSeleccionada.condicion_pago_codigo) {
            this.setCondicionPagoByCodigo(sucursalSeleccionada.condicion_pago_codigo);
          }
        }
      } else {
        this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('sucursal'), this.optionsSucursal)
      }

      this.fetchFechaVencimiento()
    })
  }

  private handleDireccionChange(value) {
    this.sucursal = this.optionsSucursal.filter(p => p.value === value)[0]
    this.onHeaderDataChange.emit(this.createHeaderData())
    if (this.cliente && this.sucursal) {
      this.fetchVendedor(this.cliente.rut, this.sucursal.codigo)
      // this.fetchFechaVencimiento()
      this.setCondicionPagoByCodigo(this.sucursal.condicion_pago_codigo)
    }
  }

  private fetchVendedor(rut, codigo_direccion) {
    const inputParams: any = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalEmpresa, // https://trello.com/c/uVoPe50E/166-01-nota-de-venta-linea-de-negocio. QA.- 2
      rutCliente: rut,
      direccionCodigo: codigo_direccion
    }

    this.log('load vendedor input params', JSON.stringify(inputParams))

    this.vendedorRubroClienteService.GetAllVendedores(inputParams, ({ registros }) => {
      this.optionsVendedor = registros.map(vendedor => ({
        value: vendedor.vendedor_codigo,
        label: vendedor.nombreVendedor,
        ...vendedor
      }))

      // Si estamos en modo edición y ya tenemos un vendedor seleccionado, establecerlo
      if (this.NvCabecera && this.NvCabecera.codigoVendedor) {
        const vendedorSeleccionado = this.optionsVendedor.find(v => v.value === this.NvCabecera.codigoVendedor);
        if (vendedorSeleccionado) {
          this.formHeader.get('vendedor').setValue(this.NvCabecera.codigoVendedor);
        } else {
          // Si no se encuentra el vendedor, usar el primero disponible
          this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('vendedor'), this.optionsVendedor)
        }
      } else {
        this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('vendedor'), this.optionsVendedor)
      }

    })
  }

  setCondicionPagoByCodigo(condicion_pago_codigo) {
    if (!condicion_pago_codigo) return;

    const _condicionPago = this.optionsCondicionPago.filter(p => p.value === condicion_pago_codigo)
    if (_condicionPago && _condicionPago.length > 0) {
      this.formHeader.get('condicionPago').setValue(_condicionPago[0].value)
      this.log('Condición de pago establecida:', _condicionPago[0].value)
    } else {
      this.log('No se encontró condición de pago con código:', condicion_pago_codigo)
    }
  }

  private fetchFechaVencimiento() {
    // private fetchFechaVencimiento = () => {
    const { fechaDoc, sucursal } = this.formHeader.value
    if (!fechaDoc || !sucursal)// || !this.formHeader.get("condicionPago")
      return

    const sucursalSeleccionada = this.optionsSucursal.filter(p => p.value === this.formHeader.get('sucursal').value)[0]
    if (!sucursalSeleccionada)
      return

    const inputParams: IFechaVencimientoQueryParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      cliente_proveedor_rut: 0,
      // direccion_codigo: this.headerData.clienteSeleccionado.codigo_direccion,
      // direccion_codigo: 0,
      direccion_codigo: sucursalSeleccionada.codigo,
      fecha_documento: this.formHeader.get("fechaDoc").value,
      // condicion_pago_codigo: sucursalSeleccionada.condicion_pago_codigo,
      condicion_pago_codigo: this.formHeader.get("condicionPago").value
    }

    this.log('fetchFechaVencimiento', JSON.stringify(inputParams))
    this.documentoService.ObtenerFechaVencimiento(inputParams, ({ mensajes, respuesta }) => {
      this.formHeader.get('fechaVenc').setValue(respuesta.fecha_vencimiento)
    })
  }

  // private handleVendedorChange(value) {
  //   // TODO: No necesito reaccionar a este cambio. Luego lo haré desde método para retornar la data del header
  //   // this.onHeaderDataChange.emit(this.createHeaderData())
  // }

  //ABRIR MODAL TABLA DE DOCS. REFERENCIA
  abrirModalDocsReferencia() {
    //enviar fecha que viene en rut cliente
    const fechaDoc = this.formHeader.get('fechaDoc').value
    this.modalDocsReferencias.show(fechaDoc);
  }


  //MOSTRAR CONTADOR DE DOCS REFERENCIAS
  getCountListDocRef($event) {
    this.CountListDocRef = $event.length
    this.documentRef = $event
  }


  public getHeaderData() {
    this.log('getHeaderData')
    return {
      unidad_negocio_codigo: this.formValidatorsService.obtenerValorFormHeader(this.formHeader, 'unidad_negocio_codigo'),
      fechaDocumento: this.formHeader.get('fechaDoc').value,
      fechaVencimiento: this.formHeader.get('fechaVenc').value,
      codigoBodega: this.formHeader.get('bodega').value,
      rutEmisor: this.rutEmpresa,
      rutCliente: this.cliente.rut, //this.formHeader.get('rutCliente').value,
      codigoSucural: this.sucursalEmpresa, //this.formHeader.get('sucursal').value,
      direccion_codigo: this.formHeader.get('sucursal').value,
      condicionPago: this.formHeader.get('condicionPago').value,
      ordenCompra: this.documentRef,
      porcentajeDescuento: this.formHeader.get('descuento').value ? this.formHeader.get('descuento').value : 0,
      codigoVendedor: this.formHeader.get('vendedor').value,
      codigoListaPrecio: this.cliente ? this.cliente.lista_precio_codigo : null,
      tipoDocumentoDTE: 2 // NOTA-VENTA // TODO: De dónde viene?
    }
  }

  public validate() {
    const unidad_negocio_codigo_state = this.formHeader.get('unidad_negocio_codigo').enabled
    this.formHeader.get('unidad_negocio_codigo').enable()

    // Add/Remove unidad_negocio_codigo validators
    if (this.permiteUnidadNegocio) {
      this.formHeader.get('unidad_negocio_codigo').setValidators([Validators.required])
    } else {
      this.formHeader.get('unidad_negocio_codigo').setValidators([])
    }
    this.formHeader.get('unidad_negocio_codigo').updateValueAndValidity()

    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!unidad_negocio_codigo_state)
      this.formHeader.get('unidad_negocio_codigo').disable()
    return this.formHeader.valid
  }

  disableContent() {
    this.enableContent = false
  }

  clearContent() {
    this.modalDocsReferencias.clearData();
    this.CountListDocRef = null;
    this.documentRef = null;
    this.enableContent = true
    this.cliente = null
    this.sucursal = null
    this.optionsSucursal = [];
    this.optionsVendedor = [];

    this.formValidatorsService.reset(this.formHeader)
    this.datePickerFechaVencimiento.clearDate()

    const now = this.datesService.CurrentDateToShortTimeString()
    // this.formHeader.get('fechaDoc').setValue(now)
    this.formHeader.get('fechaVenc').setValue(null)
    this.formHeader.get('bodega').setValue(null)
    this.formHeader.get('unidad_negocio_codigo').setValue(null)
    this.formHeader.get('rutCliente').setValue(null)
    this.formHeader.get('sucursal').setValue(null)
    this.formHeader.get('condicionPago').setValue(null)
    this.formHeader.get('oc').setValue(null)
    this.formHeader.get('descuento').setValue(null)
    this.formHeader.get('vendedor').setValue(null)
    this.formHeader.get('listaPrecios').setValue(null)
    this.formValidatorsService.reset(this.formHeader)
    this.formHeader.get('fechaDoc').setValue(now)

    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega)
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('condicionPago'), this.optionsCondicionPago)

    this.enableUnidadNegocio()
  }

  disableUnidadNegocio(unidad_negocio_codigo: number | null) {
    // this.log('bloquear unidad negocio', unidad_negocio_codigo, this.formHeader.get('unidad_negocio_codigo').value)
    if (unidad_negocio_codigo)
      this.formHeader.get('unidad_negocio_codigo').setValue(unidad_negocio_codigo)
    this.formHeader.get('unidad_negocio_codigo').disable()
  }

  enableUnidadNegocio() {
    this.formHeader.get('unidad_negocio_codigo').enable()
  }

}

